import { CheckoutSubscriptionPage } from '@/pages/checkout-subscription';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/checkout-subscription/$productPriceId')({
	component: CheckoutSubscriptionPage,
});
